import { DateTime } from 'luxon'

export const fromISO = (isoString, zone = 'UTC') => DateTime.fromISO(isoString, { zone })
